export function shuffleArray<T>(elements: T[]): T[] {
  const clonedElements = [...elements];
  const shuffledElements = [];
  // eslint-disable-next-line yoda
  while (0 < clonedElements.length) {
    const index = Math.floor(Math.random() * clonedElements.length);
    const element = clonedElements.splice(index, 1)[0];
    shuffledElements.push(element);
  }
  return shuffledElements;
}